<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/warehouses/">Warehouses</a></li>
      <li class="breadcrumb-item active" aria-current="page">Warehouse View</li>
    </ol>
  </nav>
  <form>
    <!--    <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>-->
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Warehouse Details</h2>
          <div class="row mt-3">
            <div class="col-6">
              <label class="text-black mb-3"><b>Warehouse Name : </b><span class="ml-1">{{wareHouseView.warehouseName}}</span></label>
            </div>
            <div class="col-6">
              <label class="text-black mb-3"><b>Warehouse Type :</b><span class="ml-1">{{wareHouseView.warehouseType}}</span></label>
            </div>
            <div class="col-6">
              <label class="text-black mb-3"><b>Total Space in Sq. Ft. : </b><span class="ml-1">{{wareHouseView.totalSpace}}</span></label>
            </div>
            <div class="col-6">
              <label class="text-black mb-3"><b>Cost per Sq. Ft. : </b><span class="ml-1">{{wareHouseView.cost}} /-</span></label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Address</h2>
          <div class="row mt-4">
            <div class="col-6">
              <label class="text-black mb-3"><b>Address1 :</b><span
                class="ml-1">{{wareHouseView.whAddress1}}</span></label>
            </div>
            <div class="col-6">
              <label class="text-black mb-3"><b>Address2 :</b><span
                class="ml-1">{{wareHouseView.whAddress2}}</span></label>
            </div>
            <div class="col-6">
              <label class="text-black mb-3"><b>City :</b><span class="ml-1">{{wareHouseView.whCity}}</span></label>
            </div>
            <div class="col-6">
              <label class="text-black mb-3"><b>State :</b><span class="ml-1">{{wareHouseView.whState}}</span></label>
            </div>
            <div class="col-6">
              <label class="text-black mb-3"><b>Zip :</b><span class="ml-1">{{wareHouseView.whZip}}</span></label>
            </div>
           <!-- <div class="col-6">
              <label class="text-black mb-3"><b>Geo Code :</b><span class="ml-1">{{wareHouseView.geoCode}}</span></label>
            </div>-->

          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3" *ngIf="wareHouseListView?.length">
      <div class="col">
        <div class="inner-box">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <h2 class="text-black mb-3">Assignment Details</h2>
              </tr>
              <tr>
                <th>Company Name</th>
                <th>Sq. Ft. allocated</th>
                <th>Start Date</th>
                <th>End date</th>
                <th>Auto Renew</th>
                <th>Duration</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let accountOwners of wareHouseView.accountOwnerData">
                <td>{{accountOwners.companyName}}</td>
                <td>{{accountOwners.unitsAssigned}}</td>
                <td>{{accountOwners.whStartDate}}</td>
                <td>{{accountOwners.whEndDate}}</td>
                <td>{{(accountOwners.autoRenewal == 'true' ? 'Yes' :
                  (accountOwners.autoRenewal == 'false' ? 'No' : ""))}}</td>
                <td>{{accountOwners.duration}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div><br><br>
  </form>
</section>
<div class="form-btn-section">
    <div class="row">
      <div class="col-12 text-right">
        <button type="reset" routerLink="/admin/warehouses" class="btn btn-cancel">Close</button>
      </div>
    </div>
</div>

